import React from 'react'
import "../styles/about.css"

const About = () => {
  return (
    <section className='about'>
        <div className="title__container">
            <h1 className="title__about">Про подію</h1>
        </div>        
        <div className="content__container">
            <div className="txt__container__first">
                <p className='p__about'>
                На <span> Lviv AI Community 2024: AI Studying & Future Generations </span> виступатимуть провідні фахівці зі штучного інтелекту, які поділяться практичними знаннями та надихаючими ідеями щодо майбутнього технологій, освіти та кар'єри. Це буде насичений день, що відкриє нові перспективи для студентів, молодих спеціалістів і всіх, хто прагне розвиватися в AI.
                <br />
                <br />
                Приєднуйтесь до <span> Lviv AI Community 2024: AI Studying & Future Generations, </span> щоб дізнатися про нові можливості для навчання, кар’єри та розвитку в AI. Подія стане чудовою нагодою для обміну досвідом, надихаючих дискусій та встановлення нових зв'язків!
                </p>
            </div>
            <div className="txt__container">
                {/* <p className="p__txt">
                Перша частина конференції пройде в ігровій формі. 
                <br />
                <br />
                Під час спеціального <span> LEGO воркшопу </span> Наталія Самбір, Chief Design Officer and Co-founder у Linkup Studio розповість як створювати інноваційні рішення, що змінюють поведінку користувачів і приносять користь бізнесу. 
                <br />
                <br />
                Кількість місць на воркшоп обмежена, стати його учасником можна, придбавши спеціальний “квиток із воркшопом”. 
                <br />
                <br />
                IT Meets Product відбудеться 14 листопада у Києві, зал Quoroom – <span>IQ Business Center. </span>
                <br />
                <br />
                Дізнайся як запускати продукт, що стане лідером ринку. 
                <br />
                <br />
                Купуй квитки вже сьогодні. Для учасників Львівського IT Кластера діє знижка -30% на квиток. 
                <br />
                <br />
                Залишити запит на знижку можна у вікні нижче.
                </p> */}
                <h3 className="list__title">Ви довідаєтеся про:</h3>
                <ul>
                    <li>Використання AI у навчанні: як штучний інтелект змінює освітні методики, впровадження ШІ в навчальні програми та персоналізація навчання.</li>
                    <li> Можливості для стартапів: виклики, шляхи реалізації інноваційних ідей, а також успішна історія "Від студентського проєкту до стартапу: як AI відкриває нові кар'єрні можливості".</li>
                    <li>Вплив AI на ринок праці: ключові навички для початківців, тренди та можливості для нових поколіньсучасні інструменти для ефективного маркетингу;</li>
                    <li> Бізнес-кейси: ефективні рішення та рекомендації для компаній, що впроваджують ШІ.</li>
                    <li>Як залишатися в курсі останніх досліджень в AI, зберігаючи баланс між навчанням і роботою.</li>
                </ul>
            </div>
        </div>
    </section>
  )
}

export default About
